import { render } from "./TheProduct.vue?vue&type=template&id=a9315c72&lang=pug"
import script from "./TheProduct.vue?vue&type=script&lang=js"
export * from "./TheProduct.vue?vue&type=script&lang=js"

import exportComponent from "/builds/chiedocover/chiedohome.com/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__